import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.1.09C2.725.09.8 2.06.8 4.49v22c0 2.43 1.925 4.4 4.3 4.4h25.8c2.375 0 4.3-1.97 4.3-4.4v-22c0-2.43-1.925-4.4-4.3-4.4zm25.8 26.4H5.1l8.6-17.6 6.45 13.2 4.3-8.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }